import gql from 'graphql-tag';

import slackRemoteChannelsPageFragment from '../fragments/slackRemoteChannelsPageFragment';

export const querySlackRemoteChannelsPage = gql`
  query slackRemoteChannelsPage(
    $credentialID: DokkioID!
    $cursor: String
  ) {
    slackRemoteChannelsPage(
      credentialID: $credentialID
      cursor: $cursor
    ) {
      ...slackRemoteChannelsPageFragment
    }
  }
  ${slackRemoteChannelsPageFragment}
`;

export default querySlackRemoteChannelsPage;
